// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"78848acf","247":"c98232a3","284":"d4601ddd","388":"5c671af1","627":"2c5a8063","828":"c293ba49","867":"79149a8c","917":"3480b5ed","923":"63099e4c","938":"db0072be"}[chunkId] + ".chunk.js";
};